import type { PlayerColor } from './types'

export const PLAYER_COLOR_HEX: Record<PlayerColor, string> = {
  red: '#EF4444',
  blue: '#3B82F6',
  green: '#22C55E',
  purple: '#A855F7',
  orange: '#F97316',
  teal: '#14B8A6',
}
